import { myDocumentsReferenceData, documentSummary, documentFileData } from '@/constants/MyDocumentsMockApiData';
import { AwaitResponse } from '@general/js/utils/MockUtils';
import MyDocumentsAbstractServices from './MyDocumentsAbstractServices';

export default class MyDocumentsServices extends MyDocumentsAbstractServices {
  static getReferenceData() {
    return AwaitResponse(myDocumentsReferenceData);
  }

  static getDocumentSummary() {
    return AwaitResponse(documentSummary.documents);
  }

  static getDocumentFile() {
    return AwaitResponse(documentFileData.file.data);
  }
}
